
export default {
  data() {
    return {
      mail: "",
      message: "",
      isSend: false,
    };
  },
  methods: {
    async sendMailAdress() {
      if (this.mail) {
        const regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

        if (this.mail.match(regex)) {
          try {
            // on get la personne avec le mail (le mail est unique)
            const response = await this.$axios.$get(
              `https://agily.pipedrive.com/v1/persons/search?term=${this.mail}&api_token=${process.env.API_PIPEDRIVE_TOKEN}`
            );
            // si la personne existe on met à jour le payload
            // on put la personne avec son id que l'on récupère via la response (le get)
            if (response.data.items.length > 0) {
              const payload = {
                marketing_status: "subscribed",
                label: 73,
                de74b4550c45208770b89788351208d7ee3be8aa: 12,
                "79302aacc2fcb622d82c1ab46c9239251d807322": 18,
              };
              await this.$axios.$put(
                `https://agily.pipedrive.com/v1/persons/${response.data.items[0].item.id}?api_token=${process.env.API_PIPEDRIVE_TOKEN}`,
                payload
              );
            } else {
              // sinon si la personne n'existe pas alors on l'a créer
              const payload = {
                name: this.mail,
                email: this.mail,
                marketing_status: "subscribed",
                label: 73,
                de74b4550c45208770b89788351208d7ee3be8aa: 12, // Le flag marketing qui correspond à Agily
                "79302aacc2fcb622d82c1ab46c9239251d807322": 18, // label warm lead
              };
              await this.$axios.$post(
                `https://agily.pipedrive.com/v1/persons?api_token=${process.env.API_PIPEDRIVE_TOKEN}`,
                payload
              );
            }
            this.isSend = true;
            this.message = null;
          } catch (error) {
            console.log(error);
          }
        } else {
          this.message = "Veuillez saisir un mail valide";
        }
      }
    },
  },
};
